import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=123962b1&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"
import style0 from "./SettingsPage.vue?vue&type=style&index=0&id=123962b1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123962b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('123962b1')) {
      api.createRecord('123962b1', component.options)
    } else {
      api.reload('123962b1', component.options)
    }
    module.hot.accept("./SettingsPage.vue?vue&type=template&id=123962b1&scoped=true", function () {
      api.rerender('123962b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/attendances/settings/SettingsPage.vue"
export default component.exports